"use client"

import { useState } from "react"
import Header from "../../components/protected/Header"
import Footer from "../../components/footer"
import { FaFilePdf, FaDownload, FaCheck, FaSpinner } from "react-icons/fa"
import { useTranslations } from "../../translations"
import LanguageSelector from "../../components/LanguageSelector"


const Downloads = ({ pdfFiles, downloadStatus, isDownloading, handleDownload, handleDownloadAll }) => {
  const [values] = useState({
    logged: true,
  })
  const { t } = useTranslations()

  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <div>
            <h1 className="dashboard-title mb-1">{t("downloadsDocumentation")}</h1>
            <p className="text-muted">{t("manageDownloads")}</p>
          </div>
        </div>

        <div className="modern-card mb-4" style={{ backgroundColor: 'rgba(0, 150, 255, 0.05)', border: '1px dashed var(--pastel-blue)' }}>
          <div className="d-flex align-items-center justify-content-center gap-2">
            <strong>{t("information")}:</strong> {t("downloadInfo")}
          </div>
        </div>

        <div className="row g-4">
          {pdfFiles.map((pdf) => (
            <div key={pdf.id} className="col-md-6 col-lg-4">
              <div className="modern-card h-100 d-flex flex-column">
                <div className="d-flex align-items-start mb-4">
                  <div className="pdf-icon-wrapper p-3 rounded-4 me-3" style={{ backgroundColor: 'rgba(235, 33, 120, 0.1)' }}>
                    <FaFilePdf size={32} className="text-pink" />
                  </div>
                  <div>
                    <h5 className="fw-bold color-plum mb-1">{pdf.name}</h5>
                    <p className="text-muted small mb-0">{pdf.description}</p>
                  </div>
                </div>

                <div className="mt-auto">
                  <div className="progress modern-progress mb-3">
                    <div
                      className={`progress-bar ${downloadStatus[pdf.id] ? "bg-success" : "bg-pink"}`}
                      role="progressbar"
                      style={{ 
                        width: downloadStatus[pdf.id] ? "100%" : isDownloading[pdf.id] ? "60%" : "0%",
                        backgroundColor: downloadStatus[pdf.id] ? '#28a745' : 'var(--pink-bright)'
                      }}
                      aria-valuenow={downloadStatus[pdf.id] ? 100 : isDownloading[pdf.id] ? 60 : 0}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>

                  <button
                    className={`btn-2 w-100 py-3 ${downloadStatus[pdf.id] ? "bg-success border-success" : ""}`}
                    onClick={() => handleDownload(pdf.id, pdf.name)}
                    disabled={isDownloading[pdf.id]}
                    style={downloadStatus[pdf.id] ? { backgroundColor: '#28a745' } : {}}
                  >
                    {isDownloading[pdf.id] ? (
                      <>
                        <FaSpinner className="fa-spin me-2" /> {t("downloading")}
                      </>
                    ) : downloadStatus[pdf.id] ? (
                      <>
                        <FaCheck className="me-2" /> {t("downloaded")}
                      </>
                    ) : (
                      <>
                        <FaDownload className="me-2" /> {t("downloadPDF")}
                      </>
                    )}
                  </button>

                  <div className="d-flex justify-content-between mt-3 small text-muted">
                    <span className="fw-bold text-uppercase opacity-50">PDF</span>
                    <span className="fw-bold">{pdf.fileSize}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Footer logged={values.logged} />
      </main>

      <style>{`
        .color-plum { color: var(--plum-bg); }
        .text-pink { color: var(--pink-bright); }
        .bg-pink { background-color: var(--pink-bright); }
        .modern-progress {
          height: 8px;
          border-radius: 10px;
          background-color: #f0f0f0;
          overflow: hidden;
        }
      `}</style>
    </div>
  )
}

export default Downloads
